import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import InfoNuevoAccent from "../nuevoaccent2024/InfoNuevoAccent2024";
const Footer = lazy(() => import('../footer/Footer'));
function NuevoAccent() {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="Hyundai Accent, tu compañero ideal, 100% Europeo. Galardonado por su seguridad, rendimiento, equipamiento, tecnología, amplitud y confort. Un SUV premium"
        />
        <meta
          name="keywords"
          content="Sedan, Hyundai, Hyundai Accent, Accent, seguro, amplio, alto, tecnológico, confortable"
        />
        <title>Hyundai Nuevo Accent</title>
      </Helmet>
      <Menu />
      <InfoNuevoAccent />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default NuevoAccent;